import { render } from "./Loading.vue?vue&type=template&id=4ecf5284&scoped=true"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=4ecf5284&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/PROD/okr-web-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ecf5284"]])

export default __exports__